import React, { useState } from 'react';
import './TopNav.css';

const TopNav: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="topnav">
        <div className="menu-item" onClick={() => setShowModal(true)}>
          About
        </div>
      </div>

      {showModal && (
        <div className="modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="module-card modal-window" onClick={(e) => e.stopPropagation()}>
            <div className="window-title">
              AI CRYPTO ASSISTANT v1.0
            </div>
            <div className="window-content">
              <div className="logo-container">
                <img src="/logo.png" alt="AI Crypto Assistant Logo" className="logo-image" />
              </div>
              <p style={{ fontSize: '12px', marginTop: '8px' }}>
                Ultimate advanced AI script that earns you profit by mining and staking across multiple EVM chains and Solana. Technically optimized for passive crypto yield.
              </p>
              <div style={{ marginTop: '12px' }}>
                <p><strong>Support Links:</strong></p>
                <p><a href="https://youtube.com/@ai-cryptotrading" target="_blank" rel="noreferrer">youtube.com/@ai-cryptotrading</a></p>
                <p><a href="mailto:ai-cryptotrading@engineer.com">ai-cryptotrading@engineer.com</a></p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopNav;
